import { takeLatest, fork, put, select } from 'redux-saga/effects'
import { sagas, PATIENT_RECEIVED, selectPatient } from '@medeo/patients'
import { getAccessToken } from '@medeo/user'

function* selectCurrentPatient(action) {
  const { id } = action.payload
  yield put(selectPatient(id))
}
function* rootSaga() {
  yield fork(sagas)
  yield takeLatest(PATIENT_RECEIVED, selectCurrentPatient)
  yield takeLatest(PATIENT_RECEIVED, createAuthAccount)
}

function* createAuthAccount(action) {
  try {
    const patient = action.payload
    const authAccount = {
      email: patient.telecom[1].value,
      fhirResourceType: 'Patient',
      fhirResourceId: patient.id,
      allowedApplications: [
        {
          name: 'kligo',
          role: 'patient'
        },
        {
          name: 'tls-client',
          role: 'patient'
        }
      ]
    }
    const accessToken = yield select(getAccessToken)
    yield fetch(`${process.env.AUTH_URL}/account`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'x-api-key': process.env.MEDEO_API_KEY,
        ...(accessToken != null && { Authorization: `Bearer ${accessToken}` })
      },
      body: JSON.stringify(authAccount)
    })
  } catch (error) {
    console.log(error)
  }
}

export default rootSaga



// WEBPACK FOOTER //
// ./src/Patients/sagas.js